import React from 'react'
import "./Navbar.css";
import { useNavigate} from "react-router-dom";
import logo from "./traffic.svg.png"
// import imsc from "./imsc.png"

function Navbar() {

  const navigate = useNavigate();
  return (
    <div className='Navbar'>
      <img src = {logo} alt = ""/>
      <select class = "select1" onChange={(event) =>{navigate(event.target.value)}}>
        <option value = "/app/">Traffic Index by Coords</option>
        <option value = "/app/traffic-index-zone">Traffic Index by Zone</option>
      </select>
      <a href="/app/reachability"> Reachability Map</a>
      <a href="/app/about">About</a>
    </div>
  )
}

export default Navbar 